module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/shared/promos/2023/blackfridaysale/1138x90/blackfridaysale.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/shared/promos/2023/blackfridaysale/1138x90/blackfridaysale.png
// module id = mdOo
// module chunks = 0